module.exports = __webpack_public_path__ + "img/al.c82a960c.jpg";